import { lazy, Suspense, type ComponentProps } from 'react';
import styles from './TrailMap.module.css';

const TrailMapImpl = lazy(() => import('./TrailMap').then((m) => ({ default: m.TrailMap })));

/** maplibre-gl and the basemap style weigh ~1 MB: loaded in their own chunk, after the rest of the page. */
export function TrailMap(props: ComponentProps<typeof TrailMapImpl>) {
    return (
        <Suspense
            fallback={
                <div className={`${styles.wrapper} ${props.className ?? ''}`}>
                    <div className={styles.map} />
                </div>
            }
        >
            <TrailMapImpl {...props} />
        </Suspense>
    );
}
